<template>
  <div>
    <div style="padding-top:10px;">
      <el-button size="small" icon="el-icon-back" @click="handleBack()">返回</el-button>
    </div>
    <el-card class="form-container big-form" shadow="never">
      <el-form :model="form" :rules="rules" :label-width="formLabelWidth" ref="publishForm">
        <el-form-item label="选择课程">
          <el-select v-model="form.cno" placeholder="请选择课程"  clearable :style="{width:formInputWidth}">
            <el-option :label="item.name" v-for="item in courseItems" :value="item.cno" :key="item.cno">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择项目">
          <el-select v-model="form.pno" placeholder="请选择项目"  clearable :style="{width:formInputWidth}" v-if="isEdit">
            <el-option :label="item.name" v-for="item in projectItems" :value="item.pno" :key="item.pno">
            </el-option>
          </el-select>
          <el-select v-model="form.cpnoArr" placeholder="请选择项目" multiple clearable :style="{width:formInputWidth}" v-if="!isEdit">
            <el-option :label="item.name" v-for="item in projectItems" :value="item.pno" :key="item.pno">
            </el-option>
          </el-select>          
        </el-form-item>  
        <el-form-item label="学号关联">
          <el-input :autoSize="true" v-model="batchRelatSnos" rows=4 type="textarea" placeholder="请复制学号" 
          @input="updateBatchRelatSnos()"
          :style="{width:formTextAreaWidth}">
          </el-input>
        </el-form-item>                  
        <el-form-item label="相关学生">
          <el-transfer
            style="display: inline-block"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="请输入学生名称"
            v-model="form.relationSnoArr"
            :titles="studentTitles"
            :props="{
                  key: 'sno',
                  label: 'name'
                }"            
            :data="studentItems"
            @change="reverseBatchRelatSnos()">
          </el-transfer>
        </el-form-item>
         <el-form-item label="截止时间" >
          <el-date-picker
            v-model="form.deadline"
            type="datetime"
            placeholder="请选择日期时间"
            default-time="12:00:00">
          </el-date-picker>         
        </el-form-item>              
        <el-form-item>
          <el-button size="small" type="primary" @click="submitForm('publishForm')">提交</el-button>
          <el-button size="small" v-if="!isEdit" @click="resetForm('publishForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { PROJECT_LIST, PICTURES_PROJECT,TASK_PUBLISH_LIST } from "@utils/constant"
import { selectProjectTask, addProjectTask, updateProjectTask } from '@/api/projectTask'
// import { selectAllTeacher} from '@/api/teacher'
import { selectAllCourse } from '@/api/course'
import { selectAllStudent} from '@/api/student'
import { selectAllProject} from '@/api/project'
import CommonUtil from "@utils/common-util"
const defaultForm = {
  pno: '',
  cno: '',
  snos:'',
  deadline: '',
  cpnoArr:[],
};
export default {
  name: "publishForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    queryId: {
      type: String,
    },    
  },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      rules: {
        pno: [{ require: true, message: '请输入项目编号', trigger: 'blur' }],
        name: [{ required: true, message: '请填写实验项目名称', trigger: 'blur' }],
      },
      formLabelWidth: '140px',
      formInputWidth:'400px',
      formTextAreaWidth:'460px',
      // teacherItems: [],
      studentItems:[],
      courseItems:[],
      projectItems:[],
      studentTitles: ['待选择', '已选择'], 
      batchRelatSnos:'',     
    }
  },
  // watch: {
  //   'form.relationSnoArr'() {
  //     this.batchRelatSnos = _.join(this.form.relationSnoArr, ',');
  //   },
  // },  
  created() {
    this.initInfo()
  },
  methods: {
    async initInfo() {
      let sresp = await selectAllStudent()
      this.studentItems = sresp.data.data
      let cresp = await selectAllCourse()
      this.courseItems = cresp.data.data
      let presp = await selectAllProject()
      this.projectItems = presp.data.data
      
      if (this.isEdit) {
        selectProjectTask(this.queryId).then(response => {
          let formObj = response.data.data         
          let relationSnoArr = formObj.relationSnos ? _.split(formObj.relationSnos, ',') : []
          this.batchRelatSnos = formObj.relationSnos
          this.form = Object.assign(formObj,{ relationSnoArr: relationSnoArr })
        })

      } else {
        this.form = Object.assign({}, defaultForm);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = Object.assign({}, defaultForm);
    },
    //提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }  
        //最多选200人
        if(this.form['relationSnoArr'].length && this.form['relationSnoArr'].length>250){
        this.$message({message: '关联学生不能超过250！', type: 'warning', duration: 2000  });          
          return
        }      
        this.form['relationSnos'] = _.join(this.form['relationSnoArr'], ',')
        this.form['cpnos'] = _.join(this.form['cpnoArr'], ',')
        // this.form['cpno'] = null
        CommonUtil.submitForm(this.isEdit, this.form, addProjectTask, updateProjectTask, this.handleBack)
      })
    },
    updateBatchRelatSnos(){
      this.batchRelatSnos = _.replace(this.batchRelatSnos, /\n/g, ',')      
      let tempArr =  _.split(this.batchRelatSnos, ',')
      let allSnos = _.map(this.studentItems, 'sno')     
      this.form.relationSnoArr =  _.intersection(tempArr, allSnos)
    },
    reverseBatchRelatSnos(){
       this.batchRelatSnos = _.join(this.form.relationSnoArr, ',');
    },
    handleBack() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
.big-form{
  width:900px;
}
</style>
